<template>
  <collapsible-section class='_pt0 _pb0 _bb1' :collapsed='false'>
    <template #headerText>
      <p class='color-leaf'>Member Transactions Filters</p>
    </template>
    <template #headerActions>
      <slot name="columnPicker"></slot>
    </template>
    <template #collapsibleSection>
      <form @submit.prevent="onSearch">
        <div container>
          <div grid>
            <div column>
              <app-date-input
                label="Start Date:"
                name="start-date"
                v-model="fromDate"/>
            </div>
            <div column>
              <app-date-input
                label="End Date:"
                name="end-date"
                v-model="toDate"/>
            </div>
            <div column>
              <app-select
                label="Type:"
                :has-blank-option="false"
                :options="options"
                v-model="transactionType"/>
            </div>
            <div column>
              <app-input
                label="User ID:"
                v-model="userId"/>
            </div>
            <div column class=" align-center _flex">
              <async-button type="submit" class="_mts --sm" :executing="memberTransactionsLoading">
                <template #buttonContent>
                  <span>Search</span>
                </template>
              </async-button>
            </div>
          </div>
        </div>
      </form>
    </template>
  </collapsible-section>
</template>

<script>
  import AppSelect from '@atoms/Select'
  import AppInput from '@atoms/Input'
  import AppDateInput from '@atoms/DateInput'
  import AsyncButton from '@molecules/AsyncButton'
  import CollapsibleSection from '@sections/CollapsibleSection'
  import memberManagement from '@mixins/memberManagement'
  import { mapFields } from 'vuex-map-fields'
  import { computed, onBeforeMount, watch } from '@vue/composition-api';
  import { useStore } from '@vue3shims';


  export default {
    mixins: [memberManagement],
    components: {
      CollapsibleSection,
      AppSelect,
      AsyncButton,
      AppDateInput,
      AppInput
    },
    setup() {
      const store = useStore();
      const fromDate = computed({
        get: () => store.getters['transactionSearch'].fromDate || '',
        set: (fromDate) => {
          setTransactionSearch('fromDate', fromDate);
        }
      });
      const queryParams = computed(() => store.getters['queryParams']);
      const setTransactionSearch = (field, value) => {
        let current = store.getters['transactionSearch'];
        current[field] = value;
        store.commit('SET_TRANSACTION_SEARCH', current);
      }
      const toDate = computed({
        get: () => store.getters['transactionSearch'].toDate || '',
        set: (toDate) => {
          setTransactionSearch('toDate', toDate);
        }
      });
      const transactionType = computed({
        get: () => store.getters['transactionSearch'].transactionType || '',
        set: (transactionType) => {
          setTransactionSearch('transactionType', transactionType);
        }
      });
      const userId = computed({
        get: () => store.getters['transactionSearch'].userId || '',
        set: (userId) => {
          setTransactionSearch('userId', userId)
        }
      });

      const updateSearch = () => {
        ['fromDate', 'toDate', 'transactionType', 'userId'].forEach((field) => {
          setTransactionSearch(field, queryParams.value[field]);
        });
      }

      onBeforeMount(() => {
        // console.log(`store`, store.getters['queryParams']);
        updateSearch();
      });

      watch(queryParams, () => updateSearch());  

      return {
        fromDate,
        toDate,
        transactionType,
        userId,
      }
    },
    // computed: {
    //   ...mapFields([
    //     // 'queryStringHelper.queryParams.toDate',
    //     // 'queryStringHelper.queryParams.transactionType',
    //     // 'queryStringHelper.queryParams.userId'
    //   ])
    // },
    methods: {
      onSearch() {
        let opts = {
          fromDate: this.fromDate,
          toDate: this.toDate,
          transactionType: this.transactionType,
          userId: this.userId,
        }
        this.$emit('onSearch', opts);
      }
    },
    data () {
      return {
        options: [
          { value: 'ALL', text: 'All' },
          { value: 'ADD', text: 'Add' },
          { value: 'UPDATE', text: 'Update' },
          { value: 'PRINT_ID', text: 'ID Cards' }
        ]
      }
    }
  }
</script>
